import Vue from "vue";
import axios from "axios";
import _ from "lodash";
import moment from "moment";
var Url = require("url-parse");
import Echo from "laravel-echo";

import app from "@/main";

var url = new Url(window.location.href, true);
// let b = "http://localhost:8000/api/";
// let b = "https://butosi1.geniusits.com/api/";
let b = process.env.VUE_APP_ROOT_API;
if (url.query.token) {
  axios.defaults.headers.common["Authorization"] = url.query.token;
  sessionStorage.setItem("token", url.query.token);
}

export default {
  baseUrl: b,
  http: (() => {
    let token = sessionStorage.getItem("token") || "";
    let ip = sessionStorage.getItem("ip_address");
    const instance = axios.create({
      headers: {
        Authorization: `Bearer ${token}`.replace(/"/, ""),
        device_id: ip,
      },
      baseURL: b,
    });
    instance.interceptors.request.use(
      function (config) {
        let token = sessionStorage.getItem("token");
        if (token) {
          config.headers.Authorization = `Bearer ${token}`.replace(/"/, "");
        }
        return config;
      },
      function (error) {
        return Promise.reject(error);
      },
    );

    instance.interceptors.response.use(
      (resp) => {
        return resp;
      },
      (err) => {
        if (err.response.status == 401 || err.response.status == 500) {
          console.log(err);
          sessionStorage.removeItem("token");
          app.$router.replace("/admin/login");
        } else {
          return Promise.reject(err);
        }
      },
    );
    return instance;
  })(),

  event: new Vue(),
  loader: (value) =>
    value == 0
      ? (app.$store.state.loader = false)
      : (app.$store.state.loader = true),
  loginUsingToken: (token) => sessionStorage.setItem("token", token),
  camelCase: (val) => _.startCase(_.toLower(val)),
  upperCase: (val) => _.upperCase(val),
  notify: (status, message) => {
    Vue.notify({
      group: "custom-template",
      title: "Alert !",
      text: message,
      type: status == 1 ? "success" : "error",
    });
  },
  changeDateFormat: function (d) {
    if (d != null && d != "") {
      return moment(d).format("Do MMM YYYY");
    }
    return "";
  },
  changeTimeFormat: function (d) {
    if (d != null && d != "") {
      return moment(d).format("hh:mm A");
    }
    return "";
  },
  validation: {
    required: (value) => !!value || "Required.",
    number: (value) => !isNaN(value) || "Must be a Number",
    postalLength: (value) => value > 999 || "Invalid Postal Code",
    email: (value) => {
      const pattern =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,4}\.[0-9]{1,4}\.[0-9]{1,4}\.[0-9]{1,4}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return pattern.test(value) || "Invalid e-mail.";
    },
  },
  input: {
    basic: {
      dense: true,
      outlined: true,
      "hide-details": "auto",
    },
  },
  bootEcho() {
    Vue.prototype.Pusher = require("pusher-js");
    Vue.prototype.Echo = new Echo({
      broadcaster: "pusher",
      //   key: "app-key",
      //   wsHost: "socket.butosi.com",
      //   wsPort: "443",
      //   wssPort: "443",
      //   forceTLS: false,
      //   encrypted: true,
      //   disableStats: true,
      //   enabledTransports: ["ws", "wss"],

      app_id: process.env.VUE_APP_PUSHER_ID,
      key: process.env.VUE_APP_PUSHER_KEY,
      cluster: process.env.VUE_APP_PUSHER_CLUSTER,
      encrypted: true,
      // forceTLS: true,
    });
  },
  bindEvent({ channelName, eventName, callback }) {
    this.Echo.channel(channelName).listen(eventName, callback);
  },
};
